<template>
  <div class="panel_shouyin">
    <div class="titleLine">
      <el-row>
        <!-- <el-col :span="4">
					状态：
					<el-select v-model="state" @change="changeState" placeholder="请选择" size="mini" style="width:120px;" clearable>
						<el-option v-for="item in [
							{label:'全部',value:'全部'},{label:'已使用',value:'已使用'},{label:'未使用',value:'未使用'}
						]" :key="item.value" :label="item.label"
						:value="item.value"></el-option>
					</el-select>
				</el-col> -->
        <el-col :span="10">
          类型:
          <el-select
            v-model="type"
            @change="changeType"
            placeholder="请选择"
            size="mini"
            style="width: 120px"
          >
            <el-option
              v-for="item in [
                { label: '全部', value: 0 },
                { label: '商品', value: 1 },
                { label: '洗美', value: 2 },
                { label: '病例', value: 3 },
                { label: '疫苗驱虫', value: 4 },
                { label: '医疗服务套餐', value: 5 },
                { label: '寄养', value: 6 },
                { label: '挂号', value: 7 },
                { label: '活体', value: 8 },
                { label: '虚拟类', value: 9 },
                { label: '订金', value: 10 },
              ]"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="2" :offset="8"> </el-col>
      </el-row>
    </div>
    <div class="listLine">
      <el-table :data="tableData" style="width: 100%" height="100%">
        <el-table-column label="优惠券名称" min-width="110">
          <template slot-scope="scope">
            <span>{{ scope.row.coupon_name }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="面额">
					<template slot-scope="scope">
						{{scope.row.money_reduce}}
					</template>
				</el-table-column> -->
        <el-table-column label="规则">
          <template slot-scope="scope">
            <span v-if="scope.row.activity_type == 1"
              >满 {{ scope.row.money_top }}元 减{{
                scope.row.money_reduce
              }}元</span
            >
            <span v-if="scope.row.activity_type == 2"
              >满 {{ scope.row.rebate_top }} 元打{{ scope.row.rebate*10 }}折</span
            >
            <span v-if="scope.row.activity_type == 3">抵扣</span>
          </template>
        </el-table-column>
        <el-table-column label="核销码">
          <template slot-scope="scope">
            {{ scope.row._no }}
          </template>
        </el-table-column>
        <el-table-column label="类型">
          <template slot-scope="scope">
            {{ scope.row.category_info.name }}
          </template>
        </el-table-column>
        <!-- 洗美、消费、医疗 -->
        <!-- <el-table-column label="类别" width="100">
					<template slot-scope="scope">
						<span v-for="item in scope.row.category_list" :key="item.id">
						{{item.name}}
						</span>
					</template>
				</el-table-column> -->
        <el-table-column label="领取时间">
          <template slot-scope="scope">
            <span>{{
              $public.FTime(scope.row.receive_time, "YYYY-MM-DD")
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="有效期">
          <template slot-scope="scope">
            {{ $public.FTime(scope.row.use_start_time, "YYYY-MM-DD") }} 到
            {{ $public.FTime(scope.row.use_end_time, "YYYY-MM-DD") }}
          </template>
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.use_status === 0">不可用</span>
            <span v-if="scope.row.use_status === 1">未使用</span>
            <span v-if="scope.row.use_status === 2">已使用</span>
            <span v-if="scope.row.use_status === 3">已过期</span>
          </template>
        </el-table-column>
        <el-table-column label="使用门店">
          <template slot-scope="scope">
            <span>{{
              scope.row.use_shop_id
                ? $public.getShopNameById(scope.row.use_shop_id)
                : "--"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="使用时间">
          <template slot-scope="scope">
            {{
              scope.row.use_time
                ? $public.FTime(scope.row.use_time, "YYYY-MM-DD HH:mm:ss")
                : "--"
            }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="70">
          <template slot-scope="scope">
            <el-button type="text" @click="see(scope.row)">查看</el-button>
            <!-- <el-button v-if="scope.row.use_status===1" type="text" @click="copy(scope.row)">复制核销码</el-button> -->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pageLine">
      <page
        :page="page.page"
        :pageSize="page.pageSize"
        :total="page.total"
        @change="changePage"
      ></page>
    </div>
    <div v-if="drawerSee_state">
      <discountSee :curItem="curItem" @submit="submit_drawerSee"></discountSee>
    </div>
    <textarea
      cols="20"
      rows="10"
      style="position: fixed; z-index: -1; top: 0"
      :value="noCopyed"
      id="copyFun"
    ></textarea>
  </div>
</template>
<script>
import page from "../../../../components/page.vue";
import discountSee from "../drawer/discountSee.vue";
export default {
  components: { page, discountSee },
  data() {
    return {
      type: 0,
      state: "",
      tableData: [],
      page: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      noCopyed: "",
      // see
      drawerSee_state: false,
      curItem: null,
    };
  },
  computed: {
    userInfo() {
      if (this.$store.state.mendian.userInfo._id) {
        return this.$store.state.mendian.userInfo;
      } else {
        return {
          basic_info: {},
          card_info: {},
          company_info: {},
          operation_info: {},
          pets_info: [],
          club_card: {},
        };
      }
    },
    curPetId() {
      return this.$store.state.mendian.curPetId;
    },
    curPetInfo() {
      return this.$store.getters["mendian/curPetInfo"];
    },
  },
  watch: {
    curPetInfo() {
      this.getTableData();
    },
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    add() {
      this.$store.commit("recharge/set_type", "add");
    },
    // 查看
    see(row) {
      this.curItem = row;
      this.drawerSee_state = true;
    },
    submit_drawerSee(obj) {
      console.log(obj);
      this.drawerSee_state = false;
    },
    // 复制核销码
    copy(row) {
      this.noCopyed = row._no;
      document.getElementById("copyFun").focus();
      this.$nextTick(() => {
        document.getElementById("copyFun").select();
        document.execCommand("Copy");
        this.$message({
          message: "复制成功",
          type: "success",
        });
      });
    },
    // 改变状态
    changeState() {
      console.log(this.timeRange);
    },
    // 改变类型
    changeType() {
      console.log(this.type);
      this.page.page = 1;
      this.getTableData();
    },
    // 分页
    changePage(num) {
      this.page.page = num;
      this.getTableData();
    },
    // 获取列表
    getTableData() {
      let params = {
        memberId: this.userInfo._id,
        status: 1, // -1:不限 0：不可用，1：未使用 2：已使用 3：已过期
        type: -1, //  -1：不限 、1：满减活动、2：折扣活动
        couponType: this.type, // 1 商品 2 洗美 3 病例 4 疫苗驱虫 5 医疗服务套餐 6  寄养 7 挂号 8 活体 9 虚拟类 10 订金
        pageIndex: this.page.page,
        pageSize: this.page.pageSize,
      };
      let loading = this.$loading();
      this.$http.get("/api/Member/CouponList", params).then((res) => {
        loading.close();
        if (res.code == 0) {
          console.log(res.data, "优惠");
          this.tableData = res.data.data;
          this.page.total = res.data.count;
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
.panel_shouyin {
  height: 100%;
  background-color: #fff;
  padding: 48px 0 0;
  box-sizing: border-box;
  position: relative;
  .titleLine {
    width: 100%;
    background-color: #fff;
    padding: 12px 12px 10px;
    box-sizing: border-box;
    margin-bottom: 4px;
    position: absolute;
    top: 0;
  }
  .listLine {
    height: 100%;
    padding: 0 0px 60px 0px;
    box-sizing: border-box;
  }
  .pageLine {
    position: absolute;
    bottom: 0;
    z-index: 1;
    width: 100%;
    padding: 10px;
    background-color: #fff;
    box-sizing: border-box;
  }
}
</style>
